// Gameplay constants shared across the web frontend.
// Sibling: /app/backend/app/constants/gameplay.py (keep in sync).
// Sibling: /app/mobile/src/constants/gameplay.ts (to be created if mobile grows
// duplicated literals — currently no dupes on mobile).

// Default per-object token reward used by the admin editor when the author
// hasn't specified a difficulty-specific value. Matches the backend seed
// default and the "easy" difficulty reward.
export const DEFAULT_OBJECT_TOKEN_REWARD = 5;
